import { render, staticRenderFns } from "./DispatchNoteComponent.vue?vue&type=template&id=04ddda15&scoped=true&"
import script from "./DispatchNoteComponent.vue?vue&type=script&lang=js&"
export * from "./DispatchNoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./DispatchNoteComponent.vue?vue&type=style&index=0&id=04ddda15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ddda15",
  null
  
)

export default component.exports